import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { EvaluationSourcesType } from '@/service/types';
import { THEME_MODE } from '@/contexts/theme/constants';
import { COMMON_STRING } from '@/constants/dictionary';
import { ARIA_LABEL } from '@/constants/ariaLabel';
import { InfoMessage } from '../../common/InfoMessage';
import { generalCellSx, TABLE_CELLS } from './constants';

interface EvaluationSourcesTableProps {
  data: EvaluationSourcesType[];
  onTableClick: (e: React.MouseEvent<HTMLTableSectionElement>) => void;
}

export const EvaluationSourcesTable = ({
  data,
  onTableClick,
}: EvaluationSourcesTableProps) => (
  <Table
    onClick={(e) => e.stopPropagation()}
    aria-label={ARIA_LABEL.EVALUATION_SOURCES_TABLE}
    sx={{ width: '100%', mt: 2, mb: 2, tableLayout: 'fixed' }}
  >
    <TableHead aria-label={ARIA_LABEL.EVALUATION_TABLE_HEADER}>
      <TableRow
        sx={{
          background: (theme) =>
            theme.palette.mode === THEME_MODE.DARK
              ? theme.palette.secondary.dark
              : theme.palette.background.default,
          boxShadow: 2,
        }}
      >
        {TABLE_CELLS.map(({ label, sx }) => (
          <TableCell
            key={label}
            sx={{
              ...generalCellSx,
              ...sx,
            }}
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>

    <TableBody
      onClick={onTableClick}
      aria-label={ARIA_LABEL.SOURCES_TABLE_BODY}
    >
      {!data ||
        (!data.length && (
          <TableRow>
            <TableCell colSpan={TABLE_CELLS.length} sx={{ border: 'none' }}>
              <InfoMessage message={COMMON_STRING.THERE_IS_NO_SOURCE_YET} />
            </TableCell>
          </TableRow>
        ))}

      {data.map((item) => (
        <TableRow aria-label={ARIA_LABEL.SOURCE_ROW} hover key={item.sourceId}>
          {TABLE_CELLS.map(({ value, sx }, index) => (
            <TableCell
              key={index}
              sx={{
                ...generalCellSx,
                ...sx,
              }}
            >
              {typeof value === 'function' ? value(item) : value}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
